<div class="bar">
    <div [style.width.%]="progress" class="progress"></div>
    <div class="text">{{ progress }}%</div>
</div>
